import { api } from 'app/utils/api/helpers'

export const processBackgroundCheck = (applicationGUID: string) => {
  return api.post(`/sm/backgroundcheck`, {
    applicationGUID,
  })
}
